// main.js or a plugin file

/**
 * Observes DOM mutations to automatically add a red asterisk
 * to the labels of required input fields.
 * This is particularly useful for dynamic forms or
 * single-page applications where elements are added/removed.
 */
const observer = new MutationObserver((mutations) => {
  mutations.forEach(() => {
    // Select all elements that likely represent a form field from libraries like Vuetify.
    document.querySelectorAll('.v-field--variant-filled, .v-field--variant-outlined').forEach((el) => {
      const input = el.querySelector('input, textarea, select');
      const label = el.querySelector('.v-label, .v-field-label');

      // Check if the input is required, a label exists, and the asterisk hasn't been added yet.
      if (input?.hasAttribute('required') && label && !label.dataset.asteriskAdded) {
        // Add a red asterisk to the label's inner HTML using a <sup> tag.
        // Using a class allows for easier styling control via CSS.
        label.innerHTML += `<sup class="required-asterisk" aria-hidden="true">*</sup>`;

        // Mark the label to prevent duplicate asterisks on subsequent mutations.
        label.dataset.asteriskAdded = 'true';
      }
    });
  });
});

// Start observing the entire document body for changes in child nodes and their subtrees.
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// ---
// Suggested CSS to accompany this JavaScript:
//
// .required-asterisk {
//   color: red;
//   /* You might adjust font-size if the superscript is too small/large */
//   /* font-size: 0.8em; */
//   margin-left: 2px; /* Optional: add a small space between label text and asterisk */
// }
